module.exports = __webpack_public_path__ + "media/images/expert2-e5d8df8f74b3d20d62d181a6a5ad18936d59cf7572718fe1d7f533e32daa7548.jpg";